import { TriangleAlert } from 'lucide-react'
import { KLabel } from './card'
import { RiskChip } from './chip'

/** The underwriting verdict — the largest, highest-contrast thing on the summary. */
export function VerdictBlock({
  lossProbability,
  band,
  bandTone,
  exposure,
  control,
  controlTone,
  critical,
  drift,
}: {
  lossProbability: string
  band: string
  bandTone: string
  exposure: string
  control: number
  controlTone: string
  critical?: string | null
  drift?: { label: string; tone: string }
}) {
  return (
    <div>
      {critical && (
        <div
          className="mb-3.5 flex items-start gap-2 rounded-md border p-2.5 text-xs"
          style={{
            borderColor: 'rgb(var(--ignition))',
            background: 'color-mix(in srgb, rgb(var(--ignition)) 12%, transparent)',
          }}
        >
          <TriangleAlert className="mt-px size-3.5 shrink-0 text-ignition" />
          <span>
            <b>Critical risk flag</b> — {critical}
          </span>
        </div>
      )}
      <div className="font-display text-[11px] font-medium uppercase tracking-[0.2em] text-primary">
        Loss probability
      </div>
      <div className="font-display text-[44px] font-bold leading-none tabular" style={{ color: bandTone }}>
        {lossProbability}
      </div>
      <div className="mt-1 font-display text-[15px] font-semibold" style={{ color: bandTone }}>
        {band}
      </div>
      <div className="mt-4 flex gap-6">
        <div>
          <KLabel>Exposure</KLabel>
          <div className="font-display text-[22px] font-semibold tabular">
            {exposure}
            <span className="text-[12px] font-medium text-muted-foreground">/5</span>
          </div>
        </div>
        <div>
          <KLabel>Control conf.</KLabel>
          <div className="font-display text-[22px] font-semibold tabular" style={{ color: controlTone }}>
            {control}
            <span className="text-[12px] font-medium text-muted-foreground">/100</span>
          </div>
        </div>
      </div>
      {drift && (
        <div className="mt-4">
          <RiskChip label={drift.label} tone={drift.tone} />
        </div>
      )}
    </div>
  )
}
